export const MODAL_CLASSNAME = 'favourites_modal';
export const MODAL_OVERLAY_CLASSNAME = 'favourites_modal__overlay';
